import { ApiPaths } from 'api/constants';
import { ProcessGeneral } from 'api/endpoints/processes';
import {
  SecurityGroupDetails,
  SecurityGroupGeneral,
  SecurityGroupUserGeneral,
} from 'api/endpoints/securityGroups';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { ISecurityRepo, SecurityFilter } from './ISecurityRepo';

export class SecurityRepo extends BaseRepo implements ISecurityRepo {
  getGroupDetails = (
    draft: ProcessGeneral,
    groupId: string
  ): ApiResponseAsync<SecurityGroupDetails> => {
    const link = ApiPaths.processes.byId.securityGroups.byId._({
      releaseOrDraftProcessId: draft.id,
      groupId,
    });

    return this.helpers.handleGet<SecurityGroupDetails>(link, {});
  };

  getGroupMembers = (
    draft: ProcessGeneral,
    groupId: string
  ): ApiResponseAsync<DataWithTotal<SecurityGroupUserGeneral>> => {
    const link = ApiPaths.processes.byId.securityGroups.byId.members._({
      releaseOrDraftProcessId: draft.id,
      groupId: groupId,
    });
    return this.helpers.handleGet<DataWithTotal<SecurityGroupUserGeneral>>(
      link,
      {}
    );
  };

  getGroups(
    draft: ProcessGeneral
  ): ApiResponseAsync<DataWithTotal<SecurityGroupGeneral>> {
    const link = ApiPaths.processes.byId.securityGroups._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
    });
    return this.helpers.handleGet(link);
  }
  getAvailableUsers(
    draft: ProcessGeneral
  ): ApiResponseAsync<DataWithTotal<SecurityGroupUserGeneral>> {
    const link = ApiPaths.processes.byId.securityGroups.availableUsers._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
    });
    return this.helpers.handleGet(link);
  }
  create(
    draft: ProcessGeneral,
    name: string,
    filter: SecurityFilter
  ): ApiResponseAsync<SecurityGroupDetails> {
    const link = ApiPaths.processes.byId.securityGroups._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
    });

    return this.helpers.handlePost(link, {
      name,
      securityQuery: filter,
    });
  }
  update(
    draft: ProcessGeneral,
    groupId: string,
    name: string,
    filter: SecurityFilter
  ): ApiResponseAsync<SecurityGroupDetails> {
    const link = ApiPaths.processes.byId.securityGroups.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.groupId]: groupId,
    });

    return this.helpers.handlePut(link, {
      name,
      securityQuery: filter,
    });
  }
  addMembers(
    draft: ProcessGeneral,
    groupId: string,
    users: SecurityGroupUserGeneral[]
  ): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.securityGroups.byId.members.add._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.groupId]: groupId,
    });

    return this.helpers.handlePost(link, {
      users: users.map((user) => user.id),
    });
  }
  removeMembers(
    draft: ProcessGeneral,
    groupId: string,
    users: SecurityGroupUserGeneral[]
  ): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.securityGroups.byId.members.remove._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.groupId]: groupId,
    });

    return this.helpers.handlePost(link, {
      users: users.map((user) => user.id),
    });
  }
  delete(draft: ProcessGeneral, groupId: string): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.securityGroups.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.groupId]: groupId,
    });

    return this.helpers.handleDelete(link);
  }
}
